import templateUrl from './page-publish.html';

export const pagePublishComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@',
        parentSlug: '@',
        parentName: '@'
    },

    templateUrl,

    controller: class PagePublishComponent {
        constructor($state, toastr, ModalService, PagePublishService, CompareObjectService) {
            'ngInject';

            this.$state = $state;
            this._toastr = toastr;
            this.modalService = ModalService;
            this.pagePublishService = PagePublishService;
            this.compareObjectService = CompareObjectService;
        }

        $onInit() {
            this.details = this.pagePublishService.getPagePublishStatusDetails(this.details);
            this.saveData = angular.copy(this.details);
        }

        onPageStatusListChange(list) {
            this.publishPageStatusList = list;
        }

        onSubmit() {
            this.pagePublishService.setPublishPageList(this.parentName, this.publishPageStatusList)
                .then((result) => {
                    this._toastr.success("Page Status Changed");
                    this._redirectToParentState(this.parentSlug);
                }).catch((err) => this._toastr.error(err));
        }

        //on cancel page must redirect to home banner page
        onCancel() {
            const _details = angular.copy(this.details);
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onSubmit.bind(this)
                    }]
                });
            } else {
                this._redirectToParentState(this.parentSlug);
            }

            function _onSubmit() {
                this._redirectToParentState(this.parentSlug);
            }
        }

        //************************************Private Methods************************** */

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/page-publish/page-publish.component.js